module.exports = __webpack_public_path__ + "img/dos_logo.39f11dd4.png";